/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
// import { withTracking } from 'react-tracker';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './scss/app.scss';

import Aside from '../Aside';
import Header from '../Header';
import FooterConsole from '../FooterConsole/FooterConsole';
// import NotifyBar from '../NotifyBar';
import ModalController from '../ModalController';
import Link from '../Link';

// import * as SessionActions from '../../actions/SessionActions';
import { RUNTIME_MOBILE_SIDEBAR_VISIBLE, RUNTIME_MODAL } from '../../constants';
import { setRuntimeVariable } from '../../actions/runtime';
import { sidebar } from '../../configPublic';
// import { getLandingPageEvent } from '../../tracking/events';

class Layout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    layoutType: PropTypes.oneOf(['empty', 'clear', 'default']),
    isMobileSidebarVisible: PropTypes.bool,
    sidebar: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    setModal: PropTypes.func.isRequired,
    modal: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    // trackLandingPage: PropTypes.func.isRequired,
  };

  static contextTypes = {
    routeParams: PropTypes.object.isRequired,
    url: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isMobileSidebarVisible: false,
    layoutType: 'default',
    modal: {},
    sidebar: {},
  };

  componentDidMount() {
    const {
      setModal,
      // , trackLandingPage
    } = this.props;
    setModal(null);
    // trackLandingPage();

    // OneTrust Cookies Consent Notice start
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.setAttribute(
      'data-domain-script',
      `c4b608ee-80c3-47e8-82cd-e59446f2920b-${
        process.env.APP_ENV !== 'master' ? 'test' : ''
      }`,
    );
    document.body.appendChild(script);
    window.OptanonWrapper = () => {};
    // OneTrust Cookies Consent Notice end
  }

  render() {
    const {
      sidebar,
      isMobileSidebarVisible,
      layoutType,
      children,
      setModal,
      modal,
    } = this.props;
    // const { routeParams, url } = this.context;
    const title = sidebar ? sidebar.title : [];

    if (layoutType === 'clear') {
      return <div className="app">{this.props.children}</div>;
    } else if (layoutType === 'empty') {
      return (
        <div className="app">
          {this.props.children}
          <ModalController {...modal} onClose={() => setModal(null)} />
        </div>
      );
    }

    return (
      <div className="app">
        <Aside
          config={sidebar}
          isMobileSidebarVisible={isMobileSidebarVisible}
          onClose={() => setModal(null)}
        />

        <div className="content">
          <Header
            title={title}
            isControl={sidebar && sidebar.to.includes('control-index')}
          />
          {/* <NotifyBar /> */}
          <DndProvider backend={HTML5Backend}>{children}</DndProvider>
          <FooterConsole />
        </div>

        <ModalController {...modal} onClose={() => setModal(null)} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const runtime = state.runtime;
  return {
    isMobileSidebarVisible: runtime[RUNTIME_MOBILE_SIDEBAR_VISIBLE],
    modal: runtime[RUNTIME_MODAL],
  };
};

const mapDispatchToProps = dispatch => ({
  setModal: modal =>
    dispatch(
      setRuntimeVariable({
        name: RUNTIME_MODAL,
        value: modal,
      }),
    ),
});

// const mapTrackingToProps = trackEvent => ({
//   trackLandingPage: () => {
//     trackEvent(getLandingPageEvent());
//   },
// });

export default // withTracking(mapTrackingToProps)(
connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Layout));
//  ,);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js